"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EstimatedValuesByPropertyType$ = exports.EstimatedValuesByPropertyType$outboundSchema = exports.EstimatedValuesByPropertyType$inboundSchema = void 0;
exports.estimatedValuesByPropertyTypeToJSON = estimatedValuesByPropertyTypeToJSON;
exports.estimatedValuesByPropertyTypeFromJSON = estimatedValuesByPropertyTypeFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const fastapikrakenendpointsstatsmodelssaleslocalauthoritygetestimatedvaluesresponsesstatslatestestimate_js_1 = require("./fastapikrakenendpointsstatsmodelssaleslocalauthoritygetestimatedvaluesresponsesstatslatestestimate.js");
const pricechangesestimatedvalues_js_1 = require("./pricechangesestimatedvalues.js");
const propertytype_js_1 = require("./propertytype.js");
const statsdelta_js_1 = require("./statsdelta.js");
/** @internal */
exports.EstimatedValuesByPropertyType$inboundSchema = z.object({
    delta: statsdelta_js_1.StatsDelta$inboundSchema,
    latest_estimate: fastapikrakenendpointsstatsmodelssaleslocalauthoritygetestimatedvaluesresponsesstatslatestestimate_js_1.FastapiKrakenEndpointsStatsModelsSalesLocalAuthorityGetEstimatedValuesResponsesStatsLatestEstimate$inboundSchema,
    property_type: propertytype_js_1.PropertyType$inboundSchema,
    values: z.array(pricechangesestimatedvalues_js_1.PriceChangesEstimatedValues$inboundSchema),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "latest_estimate": "latestEstimate",
        "property_type": "propertyType",
    });
});
/** @internal */
exports.EstimatedValuesByPropertyType$outboundSchema = z.object({
    delta: statsdelta_js_1.StatsDelta$outboundSchema,
    latestEstimate: fastapikrakenendpointsstatsmodelssaleslocalauthoritygetestimatedvaluesresponsesstatslatestestimate_js_1.FastapiKrakenEndpointsStatsModelsSalesLocalAuthorityGetEstimatedValuesResponsesStatsLatestEstimate$outboundSchema,
    propertyType: propertytype_js_1.PropertyType$outboundSchema,
    values: z.array(pricechangesestimatedvalues_js_1.PriceChangesEstimatedValues$outboundSchema),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        latestEstimate: "latest_estimate",
        propertyType: "property_type",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var EstimatedValuesByPropertyType$;
(function (EstimatedValuesByPropertyType$) {
    /** @deprecated use `EstimatedValuesByPropertyType$inboundSchema` instead. */
    EstimatedValuesByPropertyType$.inboundSchema = exports.EstimatedValuesByPropertyType$inboundSchema;
    /** @deprecated use `EstimatedValuesByPropertyType$outboundSchema` instead. */
    EstimatedValuesByPropertyType$.outboundSchema = exports.EstimatedValuesByPropertyType$outboundSchema;
})(EstimatedValuesByPropertyType$ || (exports.EstimatedValuesByPropertyType$ = EstimatedValuesByPropertyType$ = {}));
function estimatedValuesByPropertyTypeToJSON(estimatedValuesByPropertyType) {
    return JSON.stringify(exports.EstimatedValuesByPropertyType$outboundSchema.parse(estimatedValuesByPropertyType));
}
function estimatedValuesByPropertyTypeFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.EstimatedValuesByPropertyType$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'EstimatedValuesByPropertyType' from JSON`);
}
//# sourceMappingURL=estimatedvaluesbypropertytype.js.map